import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import useTrip from '../hooks/trip/useTrip';
import { Container } from 'semantic-ui-react';
import TripDestination from '@components/trip/TripDestination';
import { useDispatch, useSelector } from 'react-redux';
import { fetchActivities } from '../features/activities/activitiesSlice';
import { useSearchParams } from 'react-router';
import { k_token } from '../utils/storage';
import { Modal, Button } from 'semantic-ui-react';

function TripViewPage() {
    const { id } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const { fetching, data, fetchTrip, abort } = useTrip();
    const dispatch = useDispatch();
    const fetchingActivities = useSelector((state) => state.activities.fetching);
    const activities = useSelector((state) => state.activities.data);
    const [exportTxtActive, setExportTxtActive] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(searchParams);
        const token = params.get('from');
        sessionStorage.setItem(k_token, token);
        dispatch(fetchActivities());
        fetchData();
        return () => {
            abort();
        };
    }, [id, searchParams]);

    const fetchData = () => {
        fetchTrip(id).catch((error) => {
            console.error('Error fetching trip:', error);
            alert(error);
        });
    };

    const TripTextSummary = () => {
        return (
            <div>
                <div>{data.userDefined}</div>
                <div className="gap"></div>
                {data.destinations.map((destination, i) => {
                    return (
                        <div key={i}>
                            <div>
                                {destination?.plays?.map((play, j) => {
                                    const activity = activities.find((item) => item.id == play.activityID);
                                    return (
                                        <div>
                                            {j + 1}). {activity.name} {activity.nameEN && `(${activity.nameEN})`}
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="gap"></div>
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <div>
            <Container>
                <div className="gap"></div>
                {(fetching || fetchingActivities) && <p>Loading...</p>}

                <div style={{ display: 'flex', gap: '16px' }}>
                    <div style={{ fontSize: '24px', fontWeight: '500' }}>{data.userDefined}</div>
                    <button className="primary_btn slim_btn" title="导出文字" onClick={() => setExportTxtActive(true)}>
                        导出文字
                    </button>
                    <Modal onClose={() => setExportTxtActive(false)} open={exportTxtActive} closeIcon>
                        <Modal.Header>{data.userDefined}</Modal.Header>
                        <Modal.Content scrolling>
                            <TripTextSummary />
                        </Modal.Content>
                        <Modal.Actions>
                            <Button content="关闭" onClick={() => setExportTxtActive(false)} />
                        </Modal.Actions>
                    </Modal>
                </div>
                {data.notes && <div>{data.notes}</div>}

                <div className="gap"></div>

                {data.destinations?.map((item, index) => {
                    console.log('TripViewPage', item);
                    return (
                        <div key={index}>
                            <TripDestination
                                id={item.name}
                                key={index}
                                index={index}
                                destination={item}
                                // inSortMode={sortMode}
                                // draggable={sortMode}
                                callback={fetchData}
                                // handleOnDragStart={handleOnDragStart}
                                // handleOnDragOver={handleOnDragOver}
                                // handleOnDrop={handleOnDrop}
                                // compact={compact}
                            />
                            <div className="gap"></div>
                        </div>
                    );
                })}
            </Container>
        </div>
    );
}

export default TripViewPage;
